function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("polyline", {
  points: "3 6 5 6 21 6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 10,
  y1: 11,
  x2: 10,
  y2: 17
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 11,
  x2: 14,
  y2: 17
});

const SvgTrash2 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "feather feather-trash-2",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash-2.5dda1f39.svg";
export { ForwardRef as ReactComponent };